import styled from "styled-components";


export const InfoContainer = styled.div`

	background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 0.8;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoWrapper = styled.div`
	display: grid;
	z-index: 1;
	height: 550px;
	width: 100%;
	max-width: 1100px;
	margin-right: auto;
	margin-left: auto;
	/* justify-content: center; */
  @media screen and (max-width: 480px) {
		height: 850px;
    margin-bottom: 50px;
    padding-top: 70px;
	}
`;

export const InfoRow = styled.div`
	display: grid;
	grid-auto-columns: minmax(auto, 1fr);
	grid-template-areas:  'col1 col2 col3';

	@media screen and (max-width: 768px) {
		grid-template-areas:  'col1 col2 col3';
    padding-left: 3rem;
	}
	@media screen and (max-width: 480px) {
		grid-template-areas:  'col1' 'col2' 'col3';
	}
`;

export const Column1 = styled.div`
	margin-bottom: 15px;
  width: 100%;
	padding: 0 15px;
	grid-area: col1;
  margin-top: 70px;

  @media screen and (max-width: 768px) {
    padding: 0;
	}
  @media screen and (max-width: 480px) {
    margin-top: 10px;
    padding: 0;
	}
`;

export const Column2 = styled.div`
	margin-bottom: 15px;
  margin-top: 100px;
	padding: 0 15px;
  width: 100%;
  margin-right: 40px;
	grid-area: col2;

  @media screen and (max-width: 480px) {
		margin-top: 0px;
    margin-bottom: 0;
  	padding: 0 0;
	}
`;
export const Column3 = styled.div`
	margin-bottom: 15px;
  margin-top: 100px;
	padding: 0 15px;
	grid-area: col3;
  width: 100%;


  @media screen and (max-width: 480px) {
		margin-top: 0px;
    margin-bottom: 0;
    padding: 0;
	}
`;
export const TextWrapper = styled.div`
	max-width: 540px;
	padding-top: 0;
	padding-top: 100px;

  @media screen and (max-width: 480px){
		padding-top: 20px;
	}
`;

export const TopLine = styled.p`
	color: #383838;
  max-width: 315px;
	line-height: 16px;
  font: normal normal 300 15px "Spoqa Han Sans Neo";
	text-transform: capitalize;
	margin-bottom: 16px;
  text-align: left;
  letter-spacing: -0.83px;
  @media screen and (max-width: 480px){
		font-size: 14px;
    width: 65%;
	}
`;
export const HeadingDiv = styled.div`
  position: relative;
  top: 70px;
  left: 21.5%;
`
export const Icon = styled.h1`
	margin-bottom: 24px;
	font: normal normal bold 28px "Spoqa Han Sans Neo";
	line-height: 1.1;
  width: 318px;
  color: #4D565E;
	@media screen and (max-width: 480px){
		font-size: 28px;
	}
`;
export const Heading = styled.h1`
	font: normal normal bold 30px "Spoqa Han Sans Neo";
	line-height: 0.9;
  width: 152%;
  color: #2783C6;
	@media screen and (max-width: 480px){
		font-size: 28px;
    width: 85%;

	}
`;

export const Subtitle = styled.p`
	max-width: 440px;
	font: normal normal bold 18px "Spoqa Han Sans Neo";
	line-height: 24px;
  color: #000000;
  @media screen and (max-width: 480px){
		font-size: 16px;
	}
`;

export const Boldtitle = styled.p`
	max-width: 440px;
	margin-bottom: 25px;
  text-align: left;
	font: normal normal bold 21px "Spoqa Han Sans Neo";
	line-height: 24px;
  color: #383838;
  @media screen and (max-width: 480px){
		font-size: 17px;
    width: 77%;
	}
`;


export const ImgWrap =styled.div`
	max-width: 350px;
	height: auto;
`;

export const Img = styled.img`
	width: 50px;
`;